<script lang="ts">
  import { link } from "svelte-spa-router";
  import { favourites, readSet } from "../stores";
  import { categoryById } from "../categories";
  import { isStale } from "../content";
  import type { Sop } from "../types";

  export let sop: Sop;

  $: category = categoryById(sop.category);
  $: stale = isStale(sop);
  $: starred = $favourites.has(sop.slug);
  $: read = $readSet.has(sop.slug);

  function fmtDate(s: string): string {
    if (!s) return "";
    const d = new Date(s);
    if (isNaN(d.getTime())) return s;
    return d.toLocaleDateString(undefined, { month: "short", day: "numeric" });
  }

  function toggleStar(e: MouseEvent) {
    e.preventDefault();
    e.stopPropagation();
    favourites.toggle(sop.slug);
  }
</script>

<a
  use:link
  href={`/sop/${sop.slug}`}
  class="sop-card"
  class:sop-card-stub={sop.status === "stub"}
>
  <div class="flex items-start justify-between gap-3">
    <div class="flex-1 min-w-0">
      <div class="text-base font-semibold text-text truncate">{sop.title}</div>
      <div class="flex flex-wrap items-center gap-2 mt-2">
        {#if category}
          <span class="pill text-text-muted">{category.label}</span>
        {/if}
        {#if sop.type === "cheat-sheet"}
          <span class="pill bg-accent-ghost border-accent text-accent">Cheat sheet</span>
        {/if}
        {#if sop.status === "stub"}
          <span class="pill text-text-dim">Coming soon</span>
        {:else if sop.status === "draft"}
          <span class="pill text-warn border-warn/40">Draft</span>
        {/if}
        {#if stale}
          <span class="pill text-warn border-warn/40" title="Not updated in 6+ months">Stale</span>
        {/if}
        {#if read}
          <span class="pill text-accent border-accent/40">✓ Read</span>
        {/if}
      </div>
    </div>
    <button
      class="text-lg leading-none {starred ? 'text-accent' : 'text-text-dim hover:text-text-muted'}"
      on:click={toggleStar}
      aria-label={starred ? "Unstar" : "Star"}
    >
      {starred ? "★" : "☆"}
    </button>
  </div>

  {#if sop.description}
    <p class="text-sm text-text-muted line-clamp-2">{sop.description}</p>
  {/if}

  <div class="flex items-center gap-3 text-xs text-text-dim mt-auto pt-2">
    <span>by {sop.owner}</span>
    {#if sop.updated}
      <span>·</span>
      <span>updated {fmtDate(sop.updated)}</span>
    {/if}
    {#if sop.estimatedMinutes}
      <span>·</span>
      <span>{sop.estimatedMinutes} min</span>
    {/if}
  </div>
</a>
